import type { IceConfig, WarriorType } from './types.js';

/** 2: the push stops at a warrior that is crushed or falls (2026-11-05). */
export const ICE_RULES_VERSION = 2;

export const DEFAULT_ICE_CONFIG: Readonly<IceConfig> = Object.freeze({
  roundLimit: 16,
  gloryTarget: 20,
  crackEvery: 3,
  cracksPerGroan: 2,
  thawDelay: 3,
});

export const WARRIOR_TYPES: readonly WarriorType[] = ['skier', 'spear', 'huscarl'];

export const FORCE: Readonly<Record<WarriorType, number>> = { skier: 1, spear: 2, huscarl: 3 };
export const MOVE_POINTS: Readonly<Record<WarriorType, number>> = {
  skier: 4,
  spear: 3,
  huscarl: 2,
};

/** Warriors per side, by type. */
export const ARMY: Readonly<Record<WarriorType, number>> = { skier: 2, spear: 2, huscarl: 2 };
export const ARMY_SIZE = 6;

export function resolveIceConfig(overrides: Partial<IceConfig> = {}): IceConfig {
  return { ...DEFAULT_ICE_CONFIG, ...overrides };
}
